import { gql } from '@apollo/client'

const BASE_QUESTION_CATEGORY_FIELDS = gql`
  fragment BaseQuestionCategoryFields on QuestionCategoryType {
    id
    title
    subjects {
      id
      tabName
      slug
      platform {
        id
        slug
        title
      }
      isHidden
    }
  }
`

export const GET_ONE_QUESTION_CATEGORY = gql`
  ${BASE_QUESTION_CATEGORY_FIELDS}
  query findOneQuestionCategory($params: String!) {
    findOneQuestionCategory(id: $params) {
      ...BaseQuestionCategoryFields
    }
  }
`

export const GET_LIST_QUESTION_CATEGORY = gql`
  ${BASE_QUESTION_CATEGORY_FIELDS}
  query findAllQuestionCategory($params: QuestionCategoryQueryInput! = {}) {
    findAllQuestionCategory(query: $params) {
      count
      items {
        createdAt
        ...BaseQuestionCategoryFields
      }
    }
  }
`

export const CREATE_QUESTION_CATEGORY = gql`
  mutation createQuestionCategory($params: CreateQuestionCategoryInput!) {
    createQuestionCategory(createQuestionCategoryInput: $params) {
      id
      title
    }
  }
`

export const UPDATE_QUESTION_CATEGORY = gql`
  ${BASE_QUESTION_CATEGORY_FIELDS}
  mutation updateQuestionCategory($params: UpdateQuestionCategoryInput!) {
    updateQuestionCategory(updateQuestionCategoryInputFieldName: $params) {
      ...BaseQuestionCategoryFields
    }
  }
`

export const SEARCH_QUESTION_CATEGORY = gql`
  query searchQuestionCategory($searchString: String, $subjectIds: [String!]) {
    searchQuestionCategory(searchString: $searchString, subjectIds: $subjectIds) {
      count
      items {
        id
        title
      }
    }
  }
`

export const REMOVE_QUESTION_CATEGORY = gql`
  mutation removeQuestionCategory($removeQuestionCategoryId: String!) {
    removeQuestionCategory(id: $removeQuestionCategoryId) {
      affected
    }
  }
`
